import { Box, styled } from '@mui/material';
import { spaceCadet, ultraMarine } from '../../../../utils/colors';

interface StyledBoxProps {
  density: 'panel' | 'page';
}

const StyledBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'density',
})<StyledBoxProps>(({ density }) => ({
  display: 'flex',
  flexDirection: 'column',
  border: `1px solid ${spaceCadet[300]}`,
  borderRadius: 8,
  backgroundColor: 'white',
  overflow: 'hidden',

  '& .complianceGroupHeader': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: density === 'panel' ? 8 : 16,
    padding: density === 'panel' ? '11px 14px' : '12px 20px',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    textAlign: 'left',
    width: '100%',
    ...(density === 'page' && {
      fontSize: 13.5,
      fontWeight: 700,
      color: spaceCadet[500],
    }),
  },

  '& .complianceGroupHeaderLabels': {
    display: 'flex',
    flexDirection: density === 'panel' ? 'column' : 'row',
    gap: density === 'panel' ? 2 : 6,
  },

  '& .complianceGroupTitle': {
    fontSize: density === 'panel' ? 13 : 13.5,
    fontWeight: 700,
    color: spaceCadet[500],
  },

  '& .complianceGroupSummary': {
    fontSize: density === 'panel' ? 11.5 : 13,
    color: spaceCadet[400],
  },

  '& .complianceGroupToggle': {
    fontSize: 13,
    fontWeight: density === 'page' ? 700 : 400,
    color: density === 'page' ? ultraMarine[500] : spaceCadet[400],
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },

  '& .complianceGroupItems': {
    borderTop: `1px solid ${spaceCadet[100]}`,
    display: 'flex',
    flexDirection: 'column',
  },

  '& .complianceGroupRow': {
    display: 'flex',
    flexDirection: 'column',
  },

  '& .complianceGroupRowHeader': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: density === 'panel' ? 8 : 16,
    padding: density === 'panel' ? '9px 14px' : '12px 20px',
    borderTop: `1px solid ${spaceCadet[100]}`,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    borderTopWidth: 1,
    textAlign: 'left',
    width: '100%',
  },

  '& .complianceGroupRowHeaderLeft': {
    display: 'flex',
    alignItems: 'center',
    gap: density === 'panel' ? 6 : 12,
    minWidth: 0,
    overflow: 'hidden',
  },

  '& .complianceGroupRowTitle': {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
  },

  '& .complianceGroupRowTimestamp': {
    fontSize: 13,
    color: spaceCadet[400],
    flexShrink: 0,
  },

  '& .complianceGroupRowHeaderRight': {
    display: 'flex',
    alignItems: 'center',
    gap: density === 'panel' ? 8 : 12,
    flexShrink: 0,
  },

  '& .complianceGroupRowBody': {
    padding: density === 'panel' ? '2px 14px 12px' : '0 20px 16px',
    backgroundColor: density === 'panel' ? spaceCadet[100] : 'transparent',
  },

  '& .complianceGroupRowResolvedAt': {
    fontSize: 11.5,
    color: spaceCadet[400],
    marginTop: 6,
    display: 'block',
  },
}));

export default StyledBox;
